;(function(){
    var goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes=[
        {
           
            "name": "GoldenThreadSelectGoalsorObjectivesOrInterventionPopup",
            "templateUrl": "<div emr-select-goals-or-objects-or-interventions></div>",
            "directivescontrollersFiles": "files",
            "RoutingNumber": 1036,
            files:[
                "AngularScripts/SelectGoalsOrObjectsOrInterventionsView/Services/SelectGoalsOrObjectsOrInterventionsPopupService.js",
                "AngularScripts/SelectGoalsOrObjectsOrInterventionsView/Controllers/SelectGoalsOrObjectsOrInterventionsPopupController.js"
             ]
        },
    ];
    angular.module('EMR.GoldenThreadSelectGaolsOrObjectsOrInterventionsModule',[])
         .constant("goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes", goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes)
         .config(["$stateProvider", "EmrRouteProvider", "goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes",
             function ($stateProvider, EmrRouteProvider, goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes) {
                 EmrRouteProvider.registerStates(goldenThreadSelectGaolsOrObjectsOrInterventionsModuleroutes, $stateProvider);
             }]);

})();